import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    minWidth: '180px',
    maxWidth: '180px'
  },
  count: {
    color: capitalDesignTokens.foundations.colors.gray600
  }
});
